import React, { useState, useEffect, useRef } from 'react';
import { Card, Row, Col, Form, Button, Spinner, InputGroup, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import RenderizarProduto from '../components/Utils/RenderizarProduto';
import BotaoFlutuante from '../components/Button/BotaoFlutuante';
import SelecionarCategoria from '../components/Utils/SelecionarCategoria';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';
import AOS from "aos";
import 'aos/dist/aos.css';
import { useProvider, Toast, isNative} from '../context/MenuProvider';

const UploadNota = ({setEditando}) => {
  const [arquivo, setArquivo] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const {
    crud,
    salvarDados
  } = useProvider();
  const {
    post
  } = crud || {}
  
  const upload = async (e) => {
    e.preventDefault();
    if (!arquivo) return;

    try {
      const formData = new FormData();
      formData.append("arquivo", arquivo);
      setFormErrors({});
      const response = await post(
        formData,
        `/gvendas/produtos/adicionar-recompra/`,
        "multipart/form-data",
      );
      if (response && response.length){
        setArquivo(null);
        //alert(JSON.stringify(response))
        if(setEditando) setEditando(false);
        salvarDados("db_produtos", response[0]);
        Toast.fire({ icon: 'success', title: 'Estoque atualizado com sucesso' });
      }
      //alert(JSON.stringify(response));
    } catch (err) {
      const errorMessage = typeof err.response === 'string' 
                    ? {apiError:err.response} 
                    : err.response?.data;
      setFormErrors({
        ...(err?.response?.data||err?.response||err),
        apiError: errorMessage || ``
      });
      //alert(`Erro: ${JSON.stringify(err?.response?.data||err?.response||err)}`);
    }
  };

  return (
    <>
      <Form onSubmit={upload}>
        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
        <Form.Group controlId="formFile" className="mb-3">
          <small>Selecione apenas arquivo .xml da nota fiscal NFe</small>
          <InputGroup  size="sm">
            <Form.Control 
              type="file" 
              onChange={(e) => setArquivo(e.target.files[0])} 
            />
            <Button variant="primary" type="submit" disabled={!arquivo}>
              Upload NFe
            </Button>
          </InputGroup>
          {formErrors?.arquivo && <Alert variant="danger">{formErrors.arquivo}</Alert>}
        </Form.Group>
      </Form>
    </>
  );
};


const ProdutoList = () => {
    const navigate = useNavigate();
    const [avancada, setAvancada] = useState(false); 
    const [query, setQuery] = useState(''); // Termo de pesquisa
    const [extra, setExtra] = useState(null); // Produtos carregados
    const [produtos, setProdutos] = useState([]); // Produtos carregados
    const [mesclado, setMesclado] = useState(false); // Produtos carregados
    const [sincronizar, setSincronizar] = useState(false); // Produtos carregados
    const [filtroEstoque, setFiltroEstoque] = useState('todos'); // Filtro de estoque
    const [filtroCategoria, setFiltroCategoria] = useState([]); // Filtro de estoque
    const [atualizarEstoque, setAtualizarEstoque] = useState(false); // Filtro de estoque
    const [nextUrl, setNextUrl] = useState(null); // URL da próxima página
    const { 
      setLinks, 
      setBtns, 
      crud,
      salvarDados,
      buscarDados,
      hasPerms,
    } = useProvider();

    useEffect(() => {
      // Inicialize o AOS para as animações, caso esteja usando isso
      AOS.init({
        duration: 1000,
        easing: "ease-in-out",
        once: true,
        mirror: false,
      });
    }, []);
    
    const { get, loading } = crud || {};  // Obtendo os métodos do hook useCrud
    
    const handleNovoProduto = () => {
        navigate('/produtos/novo'); // Rota para cadastro de novo produto
    };
    const handleCatalogos = () => {
        navigate('/produtos/catalogos'); // Rota para cadastro de novo produto
    };
    const handleParceiros = () => {
        navigate('/produtos/parceiros'); // Rota para cadastro de novo produto
    };

    const handleEditarProduto = (id) => {
        navigate(`/produtos/editar/${id}`); // Rota para editar produto com ID específico
    };
    
    const buscarMesclagem = async() => {
      if (!hasPerms("loja.view_convitemesclagemestoque")) return;
      try{
        //const response = await get(`/gvendas/produtos-convite-mesclagem/?ordering=-data`);
        const response = await get(`/gvendas/produtos-convite-mesclagem/?is_ativo=true&ordering=-data`);
        if (response){
          setMesclado(response[0].results.length > 0);
          const atualizar = response[0].results.some(x => !x.is_sincronizado);
          setSincronizar(atualizar);
        }
      }catch(err){
        
      }finally{
        
      }
    }
    
    const updateDados = async (data) => {
      try {
        var atualizado = {
          ...data,
        }
        await salvarDados('db_produtos', atualizado);
      } catch (err) {
        console.error(err);
      }
    };
    const isConsultaCarregada = useRef(false);
    const carregarLocal = async()=>{
      if (!hasPerms("loja.view_produtos")) return;
      try{
        let response;
        if(query) {
          response = await buscarDados(
            'db_produtos',  
            (item) => {
                const searchValido = query
                  ? item.nome_do_produto?.toLowerCase().includes(query.toLowerCase())
                  : true;
                  
                const tipos = filtroCategoria?.map(t => t.trim()); // remove espaços extras
                const filtroCat = tipos?.some(t => item.tipo.includes(t));
                
                let filtroAvancado = true;
                switch(filtroEstoque){
                  case 'todos':
                    filtroAvancado = item.is_ativo;
                    break;
                  case 'comEstoque':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && parseInt(item.quantidade_em_estoque || 0)>0;
                    break;
                  case 'promocao':
                    filtroAvancado = item.is_promocao;
                    break;
                  case 'estoqueBaixo':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && item.is_estoque_baixo;
                    break;
                  case 'semEstoque':
                    filtroAvancado = item.is_ativo && item.controlar_estoque && parseInt(item.quantidade_em_estoque||0)===0;
                    break;
                  case 'inativo':
                    filtroAvancado = !item.is_ativo;
                    break;
                }
                
                  
                return searchValido && filtroCat && filtroAvancado;
            },
            10,
            "nome_do_produto",
            "asc",
          );
        }else{
          response = await buscarDados(
            'db_produtos',
            (item) => {
              return true
            },
            10,
            "nome_do_produto",
            "asc",
          );
        }
        if (isConsultaCarregada.current) return;
        if (response && response.length) {
          const base = response;
          setProdutos(base);
        }
      }catch(err){
      } finally {

      }
    }
    
    // Função para buscar produtos na API
    const buscarProdutos = async (novaBusca = false) => {
        if (!hasPerms("loja.view_produtos")) return;
        let url = `/gvendas/produtos/?expand=extra`;

        if (query) url += `&search=${query}`;
        if (!query) url += `&ordering=nome_do_produto`;
        if (filtroEstoque === 'todos') url += `&is_ativo=true`;
        else if (filtroEstoque === 'comEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque__gt=0`;
        else if (filtroEstoque === 'promocao') url += `&is_promocao=true`;
        else if (filtroEstoque === 'estoqueBaixo') url += `&is_ativo=true&controlar_estoque=true&is_estoque_baixo=true`;
        else if (filtroEstoque === 'semEstoque') url += `&is_ativo=true&controlar_estoque=true&quantidade_em_estoque=0`;
        else if (filtroEstoque === 'inativo') url += `&is_ativo=false`;
        //if (!filtroCategoria?.length) url += `&categoria__isnull=true`
        if (filtroCategoria?.length) url += `&categoria__in=${filtroCategoria}`;

        if (novaBusca) {
            //setProdutos([]); // Limpa os produtos anteriores
            setNextUrl(null); // Reseta o nextUrl
            setExtra(null);
        } else if (nextUrl) {
            url = nextUrl; // Se não for nova busca, utiliza o nextUrl
        } else {
          url = null;
        }

        if (!url) return; // Evita chamada se já estiver loading ou sem URL válida
        try{
          const response = await get(url, 'pagina');
          if(response && response.length){
            isConsultaCarregada.current = true;
            const novosProdutos = response[0].results; // Corrigir para acessar o resultado correto
            setProdutos((produtosAnteriores) => novaBusca ? novosProdutos : [...produtosAnteriores, ...novosProdutos]);
            setNextUrl(response[0].next);
            setExtra({
              quantidade:response[0].extra?.estoque,
              valor_total:response[0].extra?.total_valor,
            });
            await salvarDados("db_produtos", novosProdutos);
          }
          
        }catch(err){
          // Toast.fire({
          //     icon: "error",
          //     title: "Falha ao buscar produtos"
          // });
        }finally{
          
        }
    };

    // Carrega os produtos ao montar o componente ou aplicar um novo filtro
    useEffect(() => {
      if(atualizarEstoque) return;
      carregarLocal();
      buscarProdutos(true); // Sempre faz uma nova busca
    }, [query, atualizarEstoque, filtroEstoque, filtroCategoria]);
    
    useEffect(()=>{
      buscarMesclagem();
    },[])
    
    
    useEffect(() => {
      setLinks([
       // { name: 'Configurar estoque (Casal)', to: '/estoque/sincronizar' },
       // { name: 'Sincronizar produtos', to: '/estoque/sincronizar' },
        { name: 'Novo produto', to: '/produtos/novo' },
        { name: 'Editar em lote', to: '/produtos/atualizar-quantidade' },
        { name: 'Editar unidades', to: '/produtos/atualizar-quantidade' },
        { name: 'Nova Categoria', to: '/categorias/novo/produtos', divider:true },
        { name: 'Categorias', to: '/categorias/produtos' },
        { name: 'Novo fornecedor', to: '/marcas/novo', divider:true },
      ]);
      let lista = [
        {icon:'bx-edit', onClick:()=>{setAtualizarEstoque(!atualizarEstoque)}},
        {icon:'bi-funnel'+(avancada?'-fill':''), onClick:() => {setAvancada(!avancada); setFiltroEstoque('todos');setFiltroCategoria([]);}},
      ];
      if(mesclado){
        lista = [
          {icon:'bi bi-repeat'+(sincronizar?'-1':''), to:'/produtos/sincronizar'},
          ...lista
        ]
      }
      setBtns(lista);
      return () => {setLinks([]); setBtns([]);}
    }, [sincronizar, atualizarEstoque, mesclado, setLinks, setBtns, avancada, setAvancada]);
    
    
    
    // Detecta o fim da página para carregar mais produtos
    useEffect(() => {
        const handleScroll = () => {
            if (window.innerHeight + document.documentElement.scrollTop >= document.documentElement.offsetHeight - 100) {
                if (!loading) buscarProdutos();
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [loading, nextUrl]);
    
    const getIconesList = (item) => {
      let lista = [];
      if(item.is_sincronizado){
        lista=[...lista,'bi-link']
      }
      if(item.is_compartilhar){
        lista=[...lista,'bi-share']
      }
      return lista
    }

    
    return (
        <>
            {atualizarEstoque && (<>
              <Card className="p-2 mb-2">
                <div className="mb-2 text-center">
                  Atualize o estoque após uma recompra usando o arquivo .xml da nota fiscal ou manual usando o botão abaixo.
                </div>
                <UploadNota setEditando={setAtualizarEstoque}/>
                <div className="text-center my-2">
                  <Button size="sm" variant="outline-dark" className="px-5" onClick={()=>navigate(`/produtos/atualizar-quantidade`)}>Atualizar Manual</Button>
                </div>
              </Card>
            </>)}
            <MenuRodape extra={extra} query={query}/>
            <BotaoFlutuante to="/produtos/novo" icon="bi-plus" posicao={2}></BotaoFlutuante>
            <div className="">
                <Form>
                    <Form.Group controlId="formBasicSearch">
                      <div className="input-group">
                        <Form.Control 
                            type="text" 
                            placeholder="Digite o nome do produto" 
                            value={query} 
                            onChange={(e) => setQuery(e.target.value)} 
                        />
                        {!avancada &&(
                            <Button variant="secondary" onClick={() => buscarProdutos(true)}>
                                <i className="bi bi-search"></i>
                            </Button>
                        )}
                      </div>
                    </Form.Group>
                    {avancada && (
                    <>
                      <Form.Group controlId="formSelectStockFilter" className="mt-3">
                        <InputGroup>
                          <span className="input-group-text">Tipo</span>
                          <Form.Control 
                              as="select" 
                              value={filtroEstoque} 
                              onChange={(e) => setFiltroEstoque(e.target.value)}
                          >
                              <option value="todos">Todos</option>
                              <option value="comEstoque">Com Estoque</option>
                              <option value="promocao">Em Promoção</option>
                              <option value="estoqueBaixo">Estoque Baixo</option>
                              <option value="semEstoque">Sem Estoque</option>
                              <option value="inativo">Inativo</option>
                          </Form.Control>
                        </InputGroup>
                      </Form.Group>
                      
                      <SelecionarCategoria defaultText={` `} multiplos={true} tipo={`produtos`} categoriaId={filtroCategoria} setCategoriaId={setFiltroCategoria} label="Categoria"/>
                      
                      <Button variant="secondary" onClick={() => buscarProdutos(true)} className="mt-2 w-100">
                          Buscar
                      </Button>
                    </>
                    )}
                </Form>

                <div className="list-group mt-3">
                    {produtos.length > 0 ? (
                      produtos.map((x, index) => (
                        <div>
                          <RenderizarProduto
                            icon2={getIconesList(x)}
                            key={x.id}
                            to={`/produtos/${x.id}`}
                            src={x.foto_do_produto}
                            text1={(<>
                                {parseFloat(x.variacao||0)<0 && (<>
                                  ({x.variacao}%){` `}
                                </>)}
                                {x.categoria_text || ``}
                            </>)}
                            titulo={(<>
                              <div className="small">
                                {x.nome_do_produto}
                              </div>
                              {parseFloat(x.variacao||0)<0 && (<>
                                <s className="small text-muted">
                                  {parseFloat(x.preco_unitario||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                </s>
                              </>)}
                              {parseFloat(x.preco_de_venda||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                            </>)}
                            text2={x.controlar_estoque?`${x.quantidade_em_estoque} unidade${x.quantidade_em_estoque>1?'s':''} em estoque`:''}
                          />
                        </div>
                      ))
                    ) : (
                      !(loading) && (<>
                        <p className="text-center text-muted">Nenhum produto encontrado.</p>
                        <Row>
                          <Col xs={8} md={3} className="mx-auto text-center py-4">
                            <Button variant="outline-dark" className="w-100 my-1" onClick={handleCatalogos}>Importar de um Catálogo</Button>
                            <Button variant="outline-dark" className="w-100 my-1" onClick={handleParceiros}>Importar de um Parceiro</Button>
                            <Button variant="outline-dark" className="w-100 my-1" onClick={handleNovoProduto}>Cadastrar novo Produto</Button>
                          </Col>
                        </Row>
                      </>)
                    )}
                    {(loading) && <p className="text-center"><Spinner animation="border" /></p>}
                    {nextUrl && !(loading) && (
                        <Button data-aos="fade-up" variant="secondary" onClick={() => buscarProdutos(false)} className="mt-2  text-center">
                            Buscar mais...
                        </Button>
                    )}
                </div>
            </div>
        </>
    );
};

const MenuRodape = ({ extra, query}) => {
  if (!extra) return null;

  return (
    <div className="bs-floating shadow navbar-light">
      <div className="container py-1">
        <div className="row align-items-center">
          <div className="col">
            {query?'Filtrando ':''}{extra.quantidade} unidade{extra.quantidade>1?'s':''}
          </div>
          <div className="col-auto text-end">
            Total {' '} 
            <span className="fs-4">
              {parseFloat(extra.valor_total||0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProdutoList;